/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../common/signature';
import '../common/tipping';
import '../common/customer_management';
import '../common/order_tickets';
import '../common/payment_sounds';
import '../common/payment_types';
import '../common/security';
import '../common/store_and_forward';
import '../common/vpos/checkout';
import '../common/buyer_facing_display';
import '../common/quick_amounts';
import './item_details';
import '../common/fulfillment_types';
import './negative_stock_warning';
import '../common/cart';
import '../addons/cash_management';
import '../addons/open_tickets';
import '../addons/gift_cards';
import '../addons/invoices';
import '../addons/messages';
import '../addons/online_checkout';
import '../addons/text_message_marketing';
import '../addons/buyer_subscriptions';
import '../addons/loyalty';
import '../addons/team_management';
import '../addons/square_online';
import '../addons/estimates';
import '../addons/staff';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rtl": {
                            "nested": {
                              "RTLSettings": {
                                "fields": {
                                  "signature": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Signature",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "tipping": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tipping",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "customerManagement": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.CustomerManagement",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "orderTickets": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.OrderTickets",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "paymentSounds": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentSounds",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "paymentTypes": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentTypes",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "security": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Security",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "storeAndForward": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "addonsSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rtl.RTLSettings.AddonsSettings",
                                    "id": 9,
                                    "rule": "optional"
                                  },
                                  "checkout": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.vpos.Checkout",
                                    "id": 10,
                                    "rule": "optional"
                                  },
                                  "buyerFacingDisplay": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.BuyerFacingDisplay",
                                    "id": 11,
                                    "rule": "optional"
                                  },
                                  "quickAmount": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.QuickAmounts",
                                    "id": 12,
                                    "rule": "optional"
                                  },
                                  "itemDetails": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rtl.ItemDetails",
                                    "id": 13,
                                    "rule": "optional"
                                  },
                                  "fulfillmentTypes": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.FulfillmentTypes",
                                    "id": 14,
                                    "rule": "optional"
                                  },
                                  "negativeStockWarning": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rtl.NegativeStockWarning",
                                    "id": 15,
                                    "rule": "optional"
                                  },
                                  "cart": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Cart",
                                    "id": 16,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "AddonsSettings": {
                                    "fields": {
                                      "cashManagement": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.CashManagement",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "openTickets": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OpenTickets",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "giftCards": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.GiftCards",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "invoices": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Invoices",
                                        "id": 4,
                                        "rule": "optional"
                                      },
                                      "messages": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Messages",
                                        "id": 5,
                                        "rule": "optional"
                                      },
                                      "onlineCheckout": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OnlineCheckout",
                                        "id": 6,
                                        "rule": "optional"
                                      },
                                      "textMessageMarketing": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TextMessageMarketing",
                                        "id": 7,
                                        "rule": "optional"
                                      },
                                      "buyerSubscriptions": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.BuyerSubscriptions",
                                        "id": 8,
                                        "rule": "optional"
                                      },
                                      "loyalty": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Loyalty",
                                        "id": 9,
                                        "rule": "optional"
                                      },
                                      "teamManagement": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TeamManagement",
                                        "id": 10,
                                        "rule": "optional"
                                      },
                                      "squareOnline": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.SquareOnline",
                                        "id": 11,
                                        "rule": "optional"
                                      },
                                      "estimates": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Estimates",
                                        "id": 12,
                                        "rule": "optional"
                                      },
                                      "staff": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Staff",
                                        "id": 13,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rtl?.nested?.RTLSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rtl?.nested?.RTLSettings?.nested?.AddonsSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE RTLSettings @ squareup/devicesettings/profiles/v2/model/settings/rtl/rtl_settings.proto at 46:1
 */
export const RTLSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rtl.RTLSettings');
fixType(RTLSettings);
Builder.createAndAttachToType(RTLSettings);
/**
 * SOURCE AddonsSettings @ squareup/devicesettings/profiles/v2/model/settings/rtl/rtl_settings.proto at 65:3
 */
RTLSettings.AddonsSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rtl.RTLSettings.AddonsSettings');
fixType(RTLSettings.AddonsSettings);
Builder.createAndAttachToType(RTLSettings.AddonsSettings);